import FirstImage from "../assets/1.svg";
import SecondImage from "../assets/2.svg";
import ThirdImage from "../assets/3.svg";
import FourthImage from "../assets/4.svg";
import FifthImage from "../assets/5.svg";
import SixthImage from "../assets/6.svg";
import SeventhImage from "../assets/7.svg";
import EighthImage from "../assets/8.svg";

import "./Uses.css";
import React from "react";

const Uses = () => {
	return (
		<div>
			<section className="totally-free">
				<div className="container">
					<div className="left-content">
						<h2>Create your custom email signature for free!</h2>{" "}
						<p style={{ fontWeight: "bold" }}>
							Use this free tool to create your custom and ready-to-use email signature for your professional use. Just create an impressive branded signature, and copy & paste to your email account.
						</p>{" "}
					</div>
					<div className="right-content">
						<button
							className="button"
							onClick={() =>
								window.scrollTo({
									top: 200,
									behavior: "smooth",
								})
							}
						>
							CREATE YOUR FREE EMAIL <br />
							SIGNATURE
						</button>{" "}
					</div>{" "}
				</div>
			</section>
			<React.Fragment>
				<div
					style={{
						textAlign: "center",
						backgroundColor: "#FBFAFA",
						paddingTop: "2rem",
					}}
				>
					<h2>
						What do you Get with our Free Email Signature Generator?
					</h2>
					<br />
					<span>
						SEO Horizon's email signature generator enables you to
						generate leads and build brand identity with customized
						and professional email signatures for free.
					</span>
				</div>

				<div className="uses-container">
					<div className="useCard">
						<div className="useCard--image">
							<img
								src={FirstImage}
								alt="Professional and polite"
							/>
						</div>

						<div>
							<h3>Be professional and polite</h3>
						</div>
						<div className="useCard--content">
							<p>
								A nicely-formatted email signature just makes your letter look more polished.
							</p>
						</div>
					</div>
					<div className="useCard">
						<div className="useCard--image">
							<img src={SecondImage} alt="Cart" />
						</div>

						<div>
							<h3>More email replies</h3>
						</div>
						<div className="useCard--content">
							<p>
							An email signature makes it easy for prospects to reach out to you, and that makes them happy.
							</p>
						</div>
					</div>
					<div className="useCard">
						<div className="useCard--image">
							<img src={ThirdImage} alt="Logistics" />
						</div>

						<div>
							<h3>Increase in leads</h3>
						</div>
						<div className="useCard--content">
							<p>
								Linking to your website, blog, or online store in the signature of your emails is a great way to boost leads.
							</p>
						</div>
					</div>
					<div className="useCard">
						<div className="useCard--image">
							<img src={FourthImage} alt="Healthcare" />
						</div>

						<div>
							<h3>Works with Gmail, Outlook, Apple Mail & more</h3>
						</div>
						<div className="useCard--content">
							<p>
								You can use our email signature generator with any mail provider, such as Gmail, Outlook, Apple Mail, etc.
							</p>
						</div>
					</div>
					<div className="useCard">
						<div className="useCard--image">
							<img src={FifthImage} alt="Travel" />
						</div>

						<div>
							<h3>Create email signature in 1 min</h3>
						</div>
						<div className="useCard--content">
							<p>
								With our simple & easy to use generator, you'll be able to design your email signature in less than 60 seconds. You can instantly generate an HTML email signature with clickable links by just filling in some details.
							</p>
						</div>
					</div>
					<div className="useCard">
						<div className="useCard--image">
							<img src={SixthImage} alt="Real Estate" />
						</div>

						<div>
							<h3>Add social media links</h3>
						</div>
						<div className="useCard--content">
							<p>
								To generate leads and brand awareness, you can add social media links with icons to your email signature.
							</p>
						</div>
					</div>
					<div className="useCard">
						<div className="useCard--image">
							<img src={SeventhImage} alt="Real Estate" />
						</div>

						<div>
							<h3>Multiple design templates</h3>
						</div>
						<div className="useCard--content">
							<p>
								You can choose from a variety of professional email signature templates that are compatible with all email providers.
							</p>
						</div>
					</div>
					<div className="useCard">
						<div className="useCard--image">
							<img src={EighthImage} alt="Real Estate" />
						</div>

						<div>
							<h3>
								An improved customer experience
							</h3>
						</div>
						<div className="useCard--content">
							<p>
								With a higher customer satisfaction score, SEO Horizon's email signature generator is more popular. It has been used by thousands of companies and individuals.
							</p>
						</div>
					</div>
				</div>
			</React.Fragment>
		</div>
	);
};

export default Uses;